/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import type { AsyncRequestState } from '@modules/ui-types'

import { removeLicenseRequest } from '@/reducers/asyncRequests/registry'

import { removeLicense } from '../../../../actions/licenses'

import DeleteLicense from './DeleteLicense'

import type { ReduxState } from '@/types/redux'

interface StateProps {
  removeLicenseRequest: AsyncRequestState
}

interface DispatchProps {
  removeLicense: (regionId: string) => void
}

interface ConsumerProps {
  regionId: string
}

const mapStateToProps = (state: ReduxState, { regionId }: ConsumerProps): StateProps => ({
  removeLicenseRequest: removeLicenseRequest(state, regionId),
})

const mapDispatchToProps: DispatchProps = {
  removeLicense,
}

export default connect<StateProps, DispatchProps, ConsumerProps>(
  mapStateToProps,
  mapDispatchToProps,
)(DeleteLicense)
